var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 1.0021C7.36871 1.00896 7.06477 1.03827 6.81901 1.16349C6.53677 1.3073 6.3073 1.53677 6.16349 1.81901C6.03827 2.06477 6.00896 2.36871 6.0021 2.875M14.625 1.0021C15.1313 1.00896 15.4352 1.03827 15.681 1.16349C15.9632 1.3073 16.1927 1.53677 16.3365 1.81901C16.4617 2.06477 16.491 2.36871 16.4979 2.87499M16.4979 9.62499C16.491 10.1313 16.4617 10.4352 16.3365 10.681C16.1927 10.9632 15.9632 11.1927 15.681 11.3365C15.4352 11.4617 15.1313 11.491 14.625 11.4979M16.5 5.49999V6.99999M10.5 1H12M3.9 16H9.6C10.4401 16 10.8601 16 11.181 15.8365C11.4632 15.6927 11.6927 15.4632 11.8365 15.181C12 14.8601 12 14.4401 12 13.6V7.9C12 7.05992 12 6.63988 11.8365 6.31901C11.6927 6.03677 11.4632 5.8073 11.181 5.66349C10.8601 5.5 10.4401 5.5 9.6 5.5H3.9C3.05992 5.5 2.63988 5.5 2.31901 5.66349C2.03677 5.8073 1.8073 6.03677 1.66349 6.31901C1.5 6.63988 1.5 7.05992 1.5 7.9V13.6C1.5 14.4401 1.5 14.8601 1.66349 15.181C1.8073 15.4632 2.03677 15.6927 2.31901 15.8365C2.63988 16 3.05992 16 3.9 16Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon2);
export default __webpack_public_path__ + "static/media/copyIcon2.cec3748838932bffeb8310006a2be60a.svg";
export { ForwardRef as ReactComponent };